
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import cloneDeep from 'lodash/cloneDeep'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageSeparator,
  IFlexMessageSpan,
  IFlexMessageText,
  IFlexMessageVideo,
} from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue', 'onSelectNode', 'onFlipNode', 'onResetNode'],
})
export default class HelperButtons extends Vue {
  @Prop()
  modelValue!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  selectedPath!: string

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  nodePath!: string[]

  @Prop()
  listNodePath!: string[]

  @Prop()
  isAdmin!: boolean

  @Prop()
  errorPath!: string[]

  clipBoard: IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo = {}
  historyMessages: IFlexMessageBubble[] | IFlexMessageCarousel[] = []
  historyIndex = 0

  defaultBubble: IFlexMessageBubble = {
    type: 'bubble',
    body: {
      type: 'box',
      layout: 'vertical',
      contents: [],
    },
  }

  defaultBox: IFlexMessageBox = {
    type: 'box',
    layout: 'vertical',
    contents: [],
  }

  defaultImage: IFlexMessageImage = {
    type: 'image',
    url: 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/01_1_cafe.png',
  }

  defaultText: IFlexMessageText = {
    type: 'text',
    text: 'hello, world',
  }

  defaultButton: IFlexMessageButton = {
    type: 'button',
    action: {
      type: 'uri',
      label: 'action',
      uri: 'http://linecorp.com/',
      altUri: {},
    },
  }

  defaultFiller: IFlexMessageFiller = {
    type: 'filler',
  }

  defaultSeparator: IFlexMessageSeparator = {
    type: 'separator',
  }

  defaultVideo: IFlexMessageVideo = {
    type: 'video',
    url: 'https_url_to_video',
    previewUrl: 'https_url_to_preview_image',
    altContent: {
      type: 'image',
      size: 'full',
      aspectRatio: '20:13',
      aspectMode: 'cover',
      url: 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/01_1_cafe.png',
    },
  }

  defaultIcon: IFlexMessageIcon = {
    type: 'icon',
    url: 'https://scdn.line-apps.com/n/channel_devcenter/img/fx/review_gold_star_28.png',
  }

  defaultSpan: IFlexMessageSpan = {
    type: 'span',
    text: 'hello, world',
  }

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble | IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  get addNodeOptions() {
    const lastKey = cloneDeep(this.nodePath).pop()
    if (!lastKey || ['image', 'button', 'filler', 'separator', 'icon', 'span'].includes(lastKey)) {
      return []
    }
    const options = [
      { label: 'bubble', value: 'bubble' },
      { label: 'box', value: 'box' },
      { label: 'image', value: 'image' },
      { label: 'text', value: 'text' },
      { label: 'button', value: 'button' },
      { label: 'filler', value: 'filler' },
      { label: 'separator', value: 'separator' },
      { label: 'video', value: 'video' },
      { label: 'span', value: 'span' },
      { label: 'icon', value: 'icon' },
    ]
    if (this.selectedNode) {
      if (['header', 'hero', 'body', 'footer'].includes(lastKey)) {
        return []
      }
      const childTypes = this.getChildrenType(this.selectedNode.type, this.selectedNode.type === 'box' && 'layout' in this.selectedNode ? this.selectedNode.layout : '')
      return options.filter(option => childTypes.includes(option.value))
    } else {
      if (lastKey === 'hero') {
        return options.filter(option => ['box', 'image', 'video'].includes(option.value))
      }
      return options.filter(option => option.value === 'box')
    }
  }

  get disableCopy() {
    const lastKey = cloneDeep(this.nodePath).pop()
    if (!this.isAdmin) {
      const parentPath = this.getParentPath(this.selectedPath)
      const paths = this.getParentNodePath(parentPath)
      const parentKey = paths.pop()
      if (parentKey === 'altContent') return true
    }
    return !lastKey || ['carousel', 'header', 'hero', 'body', 'footer', 'altContent'].includes(lastKey)
  }

  get disablePaste() {
    if (!this.clipBoard.type) return true
    let paths
    let selectedNode
    if (this.isAdmin) {
      paths = cloneDeep(this.nodePath)
      selectedNode = this.selectedNode
    } else {
      const parentPath = this.getParentPath(this.selectedPath)
      paths = this.getParentNodePath(parentPath)
      selectedNode = this.getParentNodeValue(parentPath)
    }
    const lastKey = paths.pop()
    if (!lastKey || ['image', 'button', 'filler', 'separator', 'icon', 'span'].includes(lastKey)) {
      return true
    }
    console.log(selectedNode, lastKey)
    if (selectedNode) {
      if (['header', 'hero', 'body', 'footer'].includes(lastKey)) {
        return true
      }
      if (lastKey === 'altContent' && selectedNode.altContent) {
        return true
      }
      const childTypes = this.getChildrenType(selectedNode.type, selectedNode.type === 'box' && 'layout' in selectedNode ? selectedNode.layout : '')
      return !childTypes.includes(this.clipBoard.type)
    } else {
      if (lastKey === 'hero') {
        return !['box', 'image', 'video'].includes(this.clipBoard.type)
      }
      if (this.clipBoard.type !== 'box') return true
    }
    return false
  }

  get disableFlip() {
    const lastKey = cloneDeep(this.nodePath).pop()
    return !lastKey || ['carousel', 'header', 'hero', 'body', 'footer'].includes(lastKey)
  }

  get disableDelete() {
    const lastKey = cloneDeep(this.nodePath).pop()
    return !lastKey || ['carousel', 'header', 'hero', 'body', 'footer'].includes(lastKey)
  }

  get indexOfNode() {
    return this.listNodePath.indexOf(this.selectedPath)
  }

  undoChange() {
    if (this.historyIndex > 0) {
      this.historyIndex--
      this.value = cloneDeep(this.historyMessages[this.historyIndex])
      this.$emit('onSelectNode', undefined, '')
    }
  }

  redoChange() {
    if (this.historyIndex < this.historyMessages.length - 1) {
      this.historyIndex++
      this.value = cloneDeep(this.historyMessages[this.historyIndex])
      this.$emit('onSelectNode', undefined, '')
    }
  }

  copyNode() {
    this.clipBoard = cloneDeep(this.selectedNode)
    this.$q.notify({
      message: 'copied!',
      color: 'positive',
      icon: 'done',
    })
  }

  cutNode() {
    this.deleteNode()
    this.clipBoard = cloneDeep(this.selectedNode)
    this.$q.notify({
      message: 'OK!',
      color: 'positive',
      icon: 'done',
    })
  }

  addNode(type) {
    let node: IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo = {}
    if (type === 'bubble') {
      node = cloneDeep(this.defaultBubble)
    } else if (type === 'box') {
      node = cloneDeep(this.defaultBox)
    } else if (type === 'image') {
      node = cloneDeep(this.defaultImage)
    } else if (type === 'button') {
      node = cloneDeep(this.defaultButton)
    } else if (type === 'filler') {
      node = cloneDeep(this.defaultFiller)
    } else if (type === 'separator') {
      node = cloneDeep(this.defaultSeparator)
    } else if (type === 'icon') {
      node = cloneDeep(this.defaultIcon)
    } else if (type === 'span') {
      node = cloneDeep(this.defaultSpan)
    } else if (type === 'text') {
      node = cloneDeep(this.defaultText)
    } else if (type === 'video') {
      node = cloneDeep(this.defaultVideo)
    }
    const keys = cloneDeep(this.nodePath)
    const lastKey = cloneDeep(this.nodePath).pop()
    if (!lastKey) return

    if (['header', 'hero', 'body', 'footer'].includes(lastKey)) {
      const parent = keys.reduce((acc, key) => acc?.[key], this.value)
      if (!parent) {
        keys.pop()
        const parent = keys.reduce((acc, key) => acc?.[key], this.value)
        parent[lastKey] = node
      }
    } else {
      if (this.value.type === 'bubble' || (this.value.type === 'carousel' && keys.length >= 2)) {
        keys.pop()
      }

      if (keys.length === 0) return

      if (lastKey === 'altContent') {
        keys.push('altContent')
      } else if (keys[keys.length - 1] !== 'contents') {
        keys.push('contents')
      }

      let current = this.value
      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i]
        if (!current[key] || typeof current[key] !== 'object') {
          current[key] = {}
        }
        current = current[key]
      }

      const currentKey = keys[keys.length - 1]
      if (!Array.isArray(current[currentKey])) {
        current[currentKey] = []
      }
      if (lastKey === 'altContent') {
        current[currentKey] = node
      } else {
        current[currentKey].push(node)
      }
    }
    this.historyMessages.push(cloneDeep(this.value))
    this.historyIndex++
  }

  pasteNode() {
    let paths
    if (this.isAdmin) {
      paths = cloneDeep(this.nodePath)
    } else {
      const parentPath = this.getParentPath(this.selectedPath)
      paths = this.getParentNodePath(parentPath)
    }
    const keys = cloneDeep(paths)
    const lastKey = cloneDeep(paths).pop()
    if (!lastKey) return

    if (['header', 'hero', 'body', 'footer', 'altContent'].includes(lastKey)) {
      const parent = keys.reduce((acc, key) => acc?.[key], this.value)
      if (!parent) {
        keys.pop()
        const parent = keys.reduce((acc, key) => acc?.[key], this.value)
        parent[lastKey] = cloneDeep(this.clipBoard)
      }
    } else {
      if (this.value.type === 'bubble' || (this.value.type === 'carousel' && keys.length >= 2)) {
        keys.pop()
      }

      if (keys.length === 0) return

      if (keys[keys.length - 1] !== 'contents') {
        keys.push('contents')
      }

      const parent = keys.reduce((acc, key) => acc?.[key], this.value)

      if (!parent || typeof parent !== 'object') return

      if (Array.isArray(parent)) {
        parent.push(cloneDeep(this.clipBoard))
      }
    }
    this.historyMessages.push(cloneDeep(this.value))
    this.historyIndex++
    this.$emit('onResetNode')
  }

  flipNode(direction) {
    const keys = cloneDeep(this.nodePath)
    if (this.value.type === 'bubble' || (this.value.type === 'carousel' && keys.length >= 2)) {
      keys.pop()
    }

    if (keys.length === 0) return

    const lastKey = keys.pop()

    if (!lastKey) return

    const parent = keys.reduce((acc, key) => acc && acc[key], this.value)

    if (!parent || !Array.isArray(parent) || isNaN(Number(lastKey))) return

    const index = Number(lastKey)
    const newIndex = direction === 'up' ? index - 1 : index + 1

    if (newIndex < 0 || newIndex >= parent.length) return

    [parent[index], parent[newIndex]] = [parent[newIndex], parent[index]]

    this.historyMessages.push(cloneDeep(this.value))
    this.historyIndex++
    this.$emit('onFlipNode', newIndex)
  }

  deleteNode() {
    const keys = cloneDeep(this.nodePath)
    if (this.value.type === 'bubble' || (this.value.type === 'carousel' && keys.length > 2)) {
      keys.pop()
    }

    if (keys.length === 0) return

    const lastKey = keys.pop()

    if (!lastKey) return

    const parent = keys.reduce((acc, key) => acc && acc[key], this.value)

    if (!parent || typeof parent !== 'object') return

    if (Array.isArray(parent) && !isNaN(Number(lastKey))) {
      parent.splice(Number(lastKey), 1)
    } else {
      delete parent[lastKey]
    }

    this.historyMessages.push(cloneDeep(this.value))
    this.historyIndex++
    this.$emit('onResetNode')
  }

  onSelectNode(direction) {
    const index = this.indexOfNode
    if (direction === 'prev') {
      this.$emit('onSelectNode', undefined, this.listNodePath[index - 1])
    } else {
      this.$emit('onSelectNode', undefined, this.listNodePath[index + 1])
    }
  }

  getChildrenType(parent, parentLayout) {
    if (parent === 'carousel') {
      return ['bubble']
    }
    if (parent === 'header') {
      return ['box']
    }
    if (parent === 'hero') {
      return ['box', 'image', 'video']
    }
    if (parent === 'body') {
      return ['box']
    }
    if (parent === 'footer') {
      return ['box']
    }
    if (parent === 'box') {
      if (parentLayout === 'baseline') {
        return ['icon', 'text', 'filler']
      } else {
        return ['box', 'image', 'text', 'button', 'filler', 'separator']
      }
    }
    if (parent === 'text') {
      return ['span']
    }
    if (parent === 'video') {
      return ['box', 'image']
    }
    return []
  }

  initMessage(message: IFlexMessageBubble | IFlexMessageCarousel) {
    this.historyIndex = 0
    this.historyMessages = []
    this.historyMessages.push(cloneDeep(message))
    if (message.type === 'bubble') {
      this.$emit('onSelectNode', message, '0')
    } else {
      this.$emit('onSelectNode', message, 'carousel')
    }
  }

  getParentPath(path) {
    const lastDotIndex = path.lastIndexOf('.')
    if (lastDotIndex === -1) return path

    const beforeLast = path.substring(0, lastDotIndex)
    const parts = beforeLast.split('.')
    const lastSegment = parts.pop()

    if (lastSegment) {
      parts.push(lastSegment.replace(/-\d+$/, ''))
    }

    return parts.join('.')
  }

  getParentNodePath(path) {
    if (path === '') return []
    const keys = path.replace(/(box|text)-(\d+)/g, 'contents.$2').split('.')

    if (this.modelValue) {
      if (this.modelValue.type === 'bubble') {
        keys.shift()
      } else {
        const firstKey = keys.shift()
        if (firstKey) {
          keys.unshift('contents', firstKey)
        } else {
          keys.unshift('contents')
        }
      }
    }
    return keys
  }

  getParentNodeValue(path) {
    const keys = this.getParentNodePath(path)
    const lastKey = keys[keys.length - 1]
    if (this.value.type === 'bubble') {
      if (lastKey === undefined) {
        return this.value
      } else if (!['header', 'hero', 'body', 'footer'].includes(lastKey)) {
        keys.pop()
      }
    } else {
      if (lastKey === 'carousel') {
        return this.value
      } else if (['box', 'image', 'text', 'button', 'filler', 'separator', 'video', 'span', 'icon'].includes(lastKey)) {
        keys.pop()
      }
    }
    if (['header', 'hero', 'body', 'footer'].includes(lastKey)) {
      if (this.value.type !== 'bubble') {
        keys.pop()
      }
    }
    return keys.reduce((acc, key) => acc && acc[key], this.value)
  }
}
